import { CountryKeyValue, Locale } from '@headless-workspace/config';
import { ConfigByKeyRepository, Result } from '@headless-workspace/core-domain';
import { LanguageHelpers } from '@headless-workspace/utils';
import { z } from 'zod';

export const ENABLE_DELIVERY_TO_STORE = 'enableDeliveryToStore';

export interface DeliveryToStoreRepositorySpec {
    getIsDeliveryToStoreEnabled(locale: Locale): Promise<Result<boolean>>;
}

export class DeliveryToStoreRepository extends ConfigByKeyRepository implements DeliveryToStoreRepositorySpec {
    async getIsDeliveryToStoreEnabled(locale: Locale): Promise<Result<boolean>> {
        return await this.getConfigByKey(ENABLE_DELIVERY_TO_STORE, { locale }, (value) =>
            z
                .boolean()
                .nullish()
                .transform((val) => (val === null || val === undefined ? false : val))
                .parse(LanguageHelpers.retrieveDataByCountry(value as CountryKeyValue<boolean>, locale)),
        );
    }
}
